/*
 * Infinite scroll for collection and search grids (Sneakers Mafia).
 * Wraps the numbered pagination: <infinite-scroll><div class="pagination">…</div></infinite-scroll> (snippets/pagination.liquid)
 * Near the bottom it fetches the next page, appends its products and swaps in its pagination.
 * Without JS, without a product grid (blog), or if a page fails to load, the numbered pages stay as they were.
 */
if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    connectedCallback() {
      if (!this.nextUrl() || !this.grid() || !('IntersectionObserver' in window)) return;
      this.classList.add('is-active');
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) this.load();
      }, { rootMargin: '1200px 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    grid() {
      return this.parentElement && this.parentElement.querySelector('.collection-grid__wrapper > .grid');
    }

    nextUrl() {
      const a = this.querySelector('.next a');
      return a && a.href;
    }

    async load() {
      const url = this.nextUrl();
      if (this.loading || !url) return;
      this.loading = true;
      this.classList.add('is-loading');
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const nextGrid = doc.querySelector('.collection-grid__wrapper > .grid');
        if (!nextGrid) throw new Error('no product grid in ' + url);
        const nextPagination = doc.querySelector('.pagination');
        const grid = this.grid();
        grid.append(...nextGrid.children);
        if (window.theme && theme.reinitProductGridItem) theme.reinitProductGridItem(grid);
        if (window.AOS) AOS.refreshHard();
        if (!nextPagination || !nextPagination.querySelector('.next a')) {
          // Everything is on the page now: no numbered pages to show.
          this.replaceChildren();
          return this.done();
        }
        this.replaceChildren(nextPagination);
        // Still in view after a short page: observing again re-checks and loads the next one.
        this.io.unobserve(this);
        this.io.observe(this);
      } catch (e) {
        console.error('infinite-scroll', e);
        this.done(); // fall back to the numbered pages
      } finally {
        this.loading = false;
        this.classList.remove('is-loading');
      }
    }

    done() {
      this.io.disconnect();
      this.classList.remove('is-active');
    }
  }
  customElements.define('infinite-scroll', InfiniteScroll);
}
